import React from 'react'

function Services() {
    const services = [
        {
            icon: 'bi-snow',
            title: 'Cold Storage',
            desc: 'Temperature-controlled storage solutions to preserve agricultural produce and perishable goods.',
            points: [
                'Multi-temperature zones',
                'Reduced post-harvest losses',
                '24/7 monitoring',
                'Quality preservation',
            ],
        },
        {
            icon: 'bi-truck',
            title: 'Logistics Support',
            desc: 'Integrated logistics and transportation services ensuring smooth movement of goods.',
            points: [
                'End-to-end supply chain support',
                'Real-time tracking',
                'Fast distribution network',
                'Trusted logistics partners',
            ],
        },
        {
            icon: 'bi-building',
            title: 'Custom Warehousing',
            desc: 'Flexible and scalable warehousing solutions tailored to business requirements.',
            points: [
                'Custom storage layouts',
                'Bulk & pallet storage',
                'Industry-specific facilities',
                'Cost-effective solutions',
            ],
        },
    ];

    return (
        <section
            className="services-section py-5 position-relative"
            style={{
                marginTop: "-250px",
                zIndex: 10,
            }}
        >
            <div className="container">
                <div className="row g-4">
                    {services.map((service, idx) => (
                        <div key={idx} className="col-md-4">
                            <div
                                className="service-card1 h-100 shadow bg-white rounded-4 p-4"
                                data-aos="zoom-in"
                                data-aos-delay={idx * 300}
                            >
                                <div className="service-icon fs-2 text-primary">
                                    <i className={`bi ${service.icon}`}></i>
                                </div>

                                <h5 className="fw-semibold mt-3">{service.title}</h5>
                                <p className="">{service.desc}</p>

                                <ul className="service-list">
                                    {service.points.map((point, i) => (
                                        <li key={i}>{point}</li>
                                    ))}
                                </ul>

                                <button className="btn btn-sm mt-3 learn-more-btn">
                                    Learn More
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}


export default Services